import {
  Link,
  MESSAGE_BOX_VARIANT_DANGER,
  MESSAGE_BOX_VARIANT_WARNING,
  MessageBox
} from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

const ErrorFeedback = ({ error, severity, onClickReload, className }) => {
  const intl = useIntl()
  return error ? (
    <MessageBox className={className} variant={severity}>
      <span>{error}</span>{' '}
      {typeof onClickReload === 'function' && (
        <Link onClick={onClickReload}>
          {intl.formatMessage({ id: 'Load.Common.RealoadPage' })}
        </Link>
      )}
    </MessageBox>
  ) : null
}

ErrorFeedback.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  severity: PropTypes.oneOf([
    MESSAGE_BOX_VARIANT_WARNING,
    MESSAGE_BOX_VARIANT_DANGER
  ]).isRequired,
  onClickReload: PropTypes.func,
  className: PropTypes.string
}

export default ErrorFeedback
